import { inject, Injector, runInInjectionContext } from "@angular/core";
import { LanguageSelectionService } from "@shared/components/language-selection/services/language-selection/language-selection.service";
import { TranslationInfo } from "@shared/types/translation-info";
import { Duration } from "date-fns";
import { from, Observable } from "rxjs";


type DurationTranslationInfos = {
  years: TranslationInfo;
  year: TranslationInfo;
  months: TranslationInfo;
  month: TranslationInfo;
  weeks: TranslationInfo;
  week: TranslationInfo;
  days: TranslationInfo;
  day: TranslationInfo;
};

const TRANSLATION_SCOPE: string = "shared/duration";
const TRANSLATION_INFOS: DurationTranslationInfos = {
  years: {
    defaultText: "Jahre",
    token: "label-years",
    scope: TRANSLATION_SCOPE
  },
  year: {
    defaultText: "Jahr",
    token: "label-year",
    scope: TRANSLATION_SCOPE
  },
  months: {
    defaultText: "Monate",
    token: "label-moths",
    scope: TRANSLATION_SCOPE
  },
  month: {
    defaultText: "Monat",
    token: "label-moth",
    scope: TRANSLATION_SCOPE
  },
  weeks: {
    defaultText: "Wochen",
    token: "label-weeks",
    scope: TRANSLATION_SCOPE
  },
  week: {
    defaultText: "Woche",
    token: "label-week",
    scope: TRANSLATION_SCOPE
  },
  days: {
    defaultText: "Tage",
    token: "label-days",
    scope: TRANSLATION_SCOPE
  },
  day: {
    defaultText: "Tag",
    token: "label-day",
    scope: TRANSLATION_SCOPE
  }
};


function getGrammaticalNumberForDuration (duration: number | undefined, singular: Readonly<TranslationInfo>, plural: Readonly<TranslationInfo>): TranslationInfo | undefined {
  if (!duration) return undefined;

  return duration > 1 ? plural : singular;
}


/**
 * Experimentell
 *
 *
 * @beta
 */
export function getLocalizedDuration (duration: Duration, injectionContext: Injector): Observable<string> {
  return runInInjectionContext(injectionContext, () => {
    const languageSelectionService: LanguageSelectionService = inject(LanguageSelectionService);
    // eslint-disable-next-line @unicorn/consistent-function-scoping
    const format = (current: number | undefined, previous?: number): string => {
      let formattedDurationValue: string = "";

      if (current) {
        if (previous)
          formattedDurationValue += ", ";

        formattedDurationValue += `${ current.toString() } `;
      }

      return formattedDurationValue;
    };
    const yearTranslationInfo: TranslationInfo | undefined = getGrammaticalNumberForDuration(duration.years, TRANSLATION_INFOS.year, TRANSLATION_INFOS.years);
    const monthTranslationInfo: TranslationInfo | undefined = getGrammaticalNumberForDuration(duration.months, TRANSLATION_INFOS.month, TRANSLATION_INFOS.months);
    const weekTranslationInfo: TranslationInfo | undefined = getGrammaticalNumberForDuration(duration.weeks, TRANSLATION_INFOS.week, TRANSLATION_INFOS.weeks);
    const dayTranslationInfo: TranslationInfo | undefined = getGrammaticalNumberForDuration(duration.days, TRANSLATION_INFOS.day, TRANSLATION_INFOS.days);


    return from(languageSelectionService
      .getTranslatedTemplateLiteral`${ format(duration.years) }${ yearTranslationInfo
      ?? "" }${ format(duration.months, duration.years) }${ monthTranslationInfo
      ?? "" }${ format(duration.weeks, duration.months) }${ weekTranslationInfo
      ?? "" }${ format(duration.days, duration.weeks) }${ dayTranslationInfo
      ?? "" }`);
  });
}
